import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { DataTable } from "../../components/data-table";
import { GETMIGRATION_REQ } from "../../actions";
import { FlatButton } from "../../components/buttons";
import { ACL } from "../../components/acl";
import { ADMIN, PARTNER, SUPERADMIN, FINANCEADMIN } from "../../constants/roles";
import * as actions from "../../../src/actions/index";

function Migration() {

  const migrationList = useSelector((state) => state?.migration?.list);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const urlParams = useRef({});

  const handleFetch = async (params) => {
    if (params) {
      urlParams.current.page = params.page;
      urlParams.current.count = params.pageLimit;
      urlParams.current.sort_by = params.sortBy;
      urlParams.current.sort = params.sortDir;
      urlParams.current["filter.keyword"] = params.keyword || "";
    }
    dispatch(GETMIGRATION_REQ(urlParams.current));
  };

  useEffect(() => {
    dispatch(actions.RESET_STATE("migration.migrationList"))
    dispatch(actions.RESET_STATE("migration.migration_default_object"))
    dispatch(actions.RESET_STATE("migration.migration_status_list"))
    dispatch(actions.RESET_STATE("migration.migration_api_validation_result"))

  }, [])

  const migrationColumns = [
    { name: "Source Company", key: "from_company_name", disableSort: true, processClassName: () => "font-bold" },
    { name: "Source Environment", key: "from_company_region", disableSort: true },
    { name: "Destination Company", key: "to_company_name", disableSort: true, processClassName: () => "font-bold" },
    { name: "Destination Environment", key: "to_company_region", disableSort: true },
    { name: "Initiated by", key: "created_by", disableSort: true, formatText: (key) => key['name'] },
    { name: "Created on", key: "created_at", disableSort: true, formatText: (key) => moment(key).format("YYYY-MM-DD") },
    {
      name: "Status", key: "migration_status", onCellClick: (payload) => {
        navigate(`/migration/${payload.row.migration_uid}/status`);
      }, disableSort: true, formatText: (key) => key.split(' ')
        .join(' ').replace(/_/g, ' ')
        .toLowerCase(),
      processClassName: (migration_status) =>
        migration_status == "SUCCESS" ? "capitalize text-green-500 font-bold" : migration_status == "FAILED" ? "capitalize text-red-500 font-bold" : "capitalize text-[#718096] font-bold"
    },

  ];

  return (
    <main class="-mt-24">
      <div class="mx-auto h-full  max-w-[86rem] py-3 sm:px-6 lg:px-8">
        <div class="h-full flex flex-1 space-x-4">
          <section
            aria-labelledby="primary-heading"
            class="flex h-full min-w-0 flex-1 flex-col lg:order-last"
          >
            <div class="h-full">
              <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
                <div class="p-2 h-full ">
                  <div class="flow-root h-full">
                    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 h-full">
                      <div class="h-full inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                        <DataTable
                          name="Migrations"
                          enableSort={true}
                          preserve={["keyword", "page"]}
                          columns={migrationColumns}
                          remote={true}
                          data={migrationList?.data}
                          totalCount={migrationList?.totalCount}
                          handleFetch={handleFetch}
                          toolbar={{
                            search: {
                              enable: true,
                            },
                            customAction: (
                              <ACL showFor={[SUPERADMIN, ADMIN, FINANCEADMIN, PARTNER]}>
                                <FlatButton
                                  onClick={() => navigate("/migration/create")}
                                >
                                  New Migration
                                </FlatButton>
                              </ACL>
                            ),
                          }}
                          syncWithUrl={true}
                          footer={{ paginator: { enable: true, limits: [10] } }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}

export default Migration;
